<template>
  <div data-private class="flex items-center justify-center h-full p-4">
    <div class="text-center">
      <i class="fa-solid fa-spinner fa-spin text-2xl text-gray-400 mb-4"></i>
      <p class="text-gray-600">Completing sign in...</p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  async mounted() {
    if (this.$route.query.error) {
      this.$router.push({
        name: 'Login',
        query: { ssoError: this.$route.query.error },
      });
      return;
    }

    try {
      const lastVisitedRoute = localStorage.getItem('last_visited_route');
      await this.fetchUser();
      await this.initializeEntities();
      this.$router.push(lastVisitedRoute || '/');
    } catch (error) {
      const destination = localStorage.getItem('last_visited_route') || '/';
      if (error?.code === 'ECONNABORTED') {
        this.$router.push(destination);
        return;
      }
      this.$router.push({ name: 'Login' });
    }
  },
  methods: {
    ...mapActions('auth', ['fetchUser']),
    ...mapActions('entity', ['initializeEntities']),
  },
};
</script>
